import React from "react";
import styled, { css } from "styled-components";

const StyledIcon = styled.svg`
  ${({ ...props }) => css`
    color: ${props.theme.colors.primary};
  `}
`;

function HalfStarIcon() {
  return (
    <StyledIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="currentColor" fillRule="nonzero" className="cat-fill">
          <path d="M22.77 8.04l-6.553-1L13.288.836A1.42 1.42 0 0011.998 0c-.51 0-1.02.277-1.285.835L7.783 7.04l-6.554.998C.054 8.216-.417 9.73.435 10.597l4.741 4.828-1.122 6.82C3.894 23.219 4.638 24 5.47 24c.22 0 .447-.055.665-.176L12 20.604l5.863 3.221c.217.12.444.174.664.174.832 0 1.577-.779 1.417-1.753l-1.12-6.82 4.742-4.827c.852-.867.381-2.381-.794-2.56zm-5.45 5.775l-.811.825.191 1.167.874 5.318-4.573-2.512-1.002-.55.002-14.869 2.284 4.842.501 1.06 1.12.171 5.115.78-3.701 3.768z"></path>
        </g>
      </g>
    </StyledIcon>
  );
}

export default HalfStarIcon;
